import {
	PUBLIC_GOOGLE_CLIENT_ID,
	PUBLIC_ZOOM_URL,
	PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY
	// PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY
} from '$env/static/public' // from .env during builds - not Heroku's environmental variables

export const config = {
	pageSize: 10,
	defaultSortColumn: 'name',
	direction: 'ASC' as Direction,
	googleClientId: PUBLIC_GOOGLE_CLIENT_ID,
	googleRecaptchaSiteKey: PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
	// cloudflareTurnstileSiteKey: PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY,
	zoomUrl: PUBLIC_ZOOM_URL
}
